import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import PortImage10 from '../../images/background/back_service.jpg';
import ClientLogo1 from '../elements/client-logo/client-logo-1';

class IndustryOilGas extends Component {
	
	render(){
		return (
			<>
				<Header1 />
				
				<div className="page-content bg-white">
					
					<div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
						<div className="container" style={{marginTop:56}}>
							<div className="page-banner-entry">
								<h1 className="text-white">Oil & Gas (Onshore / Offshore)</h1>
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
										<li>Industries</li>
									</ul>
								</div>
							 </div>
						</div>
					</div>
					
					<div className="content-block" id="content-area">
						
						<div className="section-area section-sp2 port-7-content">
							<div className="container">
								<div className="row">
									<div className="col-lg-7">
										<div className="heading-bx text-left m-b20">
											<h3 className="title-head m-b0">Oil & Gas Expertise</h3>
											<div className="ttr-separator sepimg"></div>
										</div>

										<p>
											GO-PS delivers comprehensive and advanced solutions tailored to both upstream and downstream operations, supporting clients across onshore and offshore environments. Our expertise spans the full lifecycle of oil and gas assets, from exploration to production and long-term integrity.

<br />We provide specialised support in reservoir characterisation and modelling, drilling planning and performance optimisation, well intervention and stimulation, and production enhancement through advanced technologies and field-proven methodologies.

<br/>Our services also extend to complete asset integrity management, ensuring safe, reliable, and efficient operations throughout all phases of the energy value chain—maximising recovery, minimising downtime, and improving overall operational performance.
										</p>
										
									</div>
									<div className="col-lg-5">
										<div className="row sp4 magnific-image sticky-top">
											<div className="action-card col-lg-12 wow fadeInUp" data-wow-delay="0.6s">
												<div className="portfolio-box ">
													<div className="portfolio-media" >
														<img src={PortImage10} alt="" style={{ border: "6px solid #ff6600"  }}/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
					<div className="section-area section-sp2 bg-gray">
							<div className="container wow fadeIn" data-wow-delay="0.8s">
								<div className="heading-bx text-center">
									<h6 className="title-ext m-b0">Our Partner</h6>
									<h2 className="title-head m-b0">Partners & Clients</h2>
									<div className="ttr-separator sepimg"></div>
								</div>
								
								<ClientLogo1 />
						
							</div>
						</div>
				</div>
				
				<Footer1 />
				
			</>
		);
	}
}

export default IndustryOilGas;
